import { render } from "./DeleteFluxo.vue?vue&type=template&id=5a1159be"
import script from "./DeleteFluxo.vue?vue&type=script&lang=js"
export * from "./DeleteFluxo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__